// extracted by mini-css-extract-plugin
export default {"textAreaWrapper":"textAreaWrapper__IBECC","withScreenshot":"withScreenshot__zhvy6","withBorder":"withBorder__PSqce","focus":"focus__XeaMB"};